export const GET_SUBJECT_REQUEST = "GET_SUBJECT_REQUEST";
export const GET_SUBJECT_SUCCESS = "GET_SUBJECT_SUCCESS";
export const GET_SUBJECT_FAIL = "GET_SUBJECT_FAIL";




